import React from 'react';
import { MapPin, Quote } from 'lucide-react';
import { aboutData } from '../mock';

const AboutSection = () => {
  return (
    <section id="sobre-mi" className="py-24 bg-black relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono mb-4 inline-block">
              {'<'} Sobre Mí {'/>'}
            </h2>
            <div className="flex items-center justify-center gap-2 text-gray-400 mt-4">
              <MapPin size={20} className="text-green-400" />
              <span className="font-mono">{aboutData.location}</span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative group">
              <div className="absolute inset-0 bg-green-500/20 rounded-lg transform rotate-3 group-hover:rotate-6 transition-transform"></div>
              <img
                src={aboutData.image}
                alt={aboutData.name}
                className="relative rounded-lg w-full shadow-2xl shadow-green-500/20 transform group-hover:scale-105 transition-transform"
              />
              <div className="absolute inset-0 border-2 border-green-500/30 rounded-lg"></div>
            </div>

            {/* Bio */}
            <div className="space-y-6">
              <div className="bg-gray-900/50 border border-green-500/30 rounded-lg p-8 backdrop-blur-sm">
                <p className="text-gray-300 leading-relaxed whitespace-pre-line text-lg">
                  {aboutData.bio}
                </p>
              </div>

              <div className="flex items-start gap-4 bg-green-500/5 border border-green-500/20 rounded-lg p-6">
                <Quote className="text-green-400 flex-shrink-0 mt-1" size={24} />
                <p className="text-gray-400 italic">
                  "El tipo puede cambiar de todo. De cara, de casa, de familia, de novia, de religión, de dios. Pero hay una cosa que no puede cambiar Benjamín, no puede cambiar de pasión.
                  <br /><br />
                  El secreto de sus ojos."
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 text-center">
                <div className="bg-gray-900/50 border border-green-500/30 rounded-lg p-4">
                  <p className="text-3xl font-bold text-green-400 font-mono">30+</p>
                  <p className="text-gray-400 text-sm font-mono mt-2">Años experiencia</p>
                </div>
                <div className="bg-gray-900/50 border border-green-500/30 rounded-lg p-4">
                  <p className="text-3xl font-bold text-green-400 font-mono">40+</p>
                  <p className="text-gray-400 text-sm font-mono mt-2">Proyectos completados</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;